import { render } from "./InputAmount.vue?vue&type=template&id=578a335b"
import script from "./InputAmount.vue?vue&type=script&lang=js"
export * from "./InputAmount.vue?vue&type=script&lang=js"
script.render = render

export default script